import { apiClient } from "./client";
import type { OrdersDatasetResponse } from "./types";
import type { OrderRow } from "../../types";

export type OrdersDatasetQuery = {
    dateFrom?: string;
    dateTo?: string;
    traderId?: string;
    region?: string;
};

export type OnlineOrderPaymentRow = {
    objectName: string;
    operationName: string;
    paymentTypeName: string;
    paidAt: string;
    amount: number;
};

export type OnlineOrdersPaymentsResponse = {
    payments: OnlineOrderPaymentRow[];
    summary: {
        count: number;
        totalAmount: number;
    };
};

export async function fetchOrdersDataset(filters?: OrdersDatasetQuery) {
    const response = await apiClient.get<OrdersDatasetResponse>("/orders", {
        params: {
            ...(filters?.dateFrom ? { date_from: filters.dateFrom } : {}),
            ...(filters?.dateTo ? { date_to: filters.dateTo } : {}),
            ...(filters?.traderId && filters.traderId !== "Всички"
                ? { trader_id: filters.traderId }
                : {}),
            ...(filters?.region && filters.region !== "Всички" ? { region: filters.region } : {}),
        },
        timeout: 120_000,
    });

    return response.data;
}

export async function fetchOnlineOrdersPayments(filters?: { dateFrom?: string; dateTo?: string }) {
    const response = await apiClient.get<OnlineOrdersPaymentsResponse>("/orders/online-payments", {
        params: {
            ...(filters?.dateFrom ? { date_from: filters.dateFrom } : {}),
            ...(filters?.dateTo ? { date_to: filters.dateTo } : {}),
        },
        timeout: 120_000,
    });

    return response.data;
}

export async function fetchOrderDetails(orderNumber: string) {
    const response = await apiClient.get<{ order: OrderRow | null }>("/orders/item-details", {
        params: {
            order: orderNumber,
        },
        timeout: 120_000,
    });

    return response.data;
}
